window.AV = require('leancloud-storage');
window.Valine = require('./Valine/dist/Valine.min.js');